(() => {
  function init(root) {
    root.querySelectorAll('.es-contact__form').forEach(form => {
      if (form.dataset.contactReady) return;
      form.dataset.contactReady = 'true';
      const topic = form.querySelector('[data-contact-topic]');
      const order = form.querySelector('[data-contact-order]');
      const message = form.querySelector('textarea[name="contact[body]"]');
      if (topic && order) {
        const update = () => {
          const relevant = topic.selectedOptions[0]?.hasAttribute('data-order-topic');
          order.hidden = !relevant;
          order.querySelector('input').disabled = !relevant;
        };
        topic.addEventListener('change', update);
        update();
      }
      const first = form.querySelector('[data-contact-first-name]'), last = form.querySelector('[data-contact-last-name]'), full = form.querySelector('[data-contact-full-name]');
      if (first && last && full) {
        // F-134: the hello@ notification's name line keeps showing the shopper's full name.
        const join = () => { full.value = [first.value, last.value].map(part => part.trim()).filter(Boolean).join(' '); };
        form.addEventListener('input', join);
        form.addEventListener('submit', join);
      }
      if (message) {
        const check = () => message.setCustomValidity(message.value.trim() ? '' : 'Please tell us what you need help with.');
        message.addEventListener('input', check);
        check();
      }
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  // F-134e: Shopify's CAPTCHA wires up on the first touch inside the form and drops a Send tap that comes
  // before it is ready (a restored draft or signed-in details leave nothing else to touch). Send that tap
  // once CAPTCHA is ready, through Shopify's supported Shopify.captcha.protect.
  window.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.classList.contains('es-contact__form')) return;
    if (!event.defaultPrevented || form.hasAttribute('data-hcaptcha-bound') || form.dataset.contactQueued) return;
    const captcha = window.Shopify && window.Shopify.captcha;
    if (!captcha || typeof captcha.protect !== 'function') return;
    form.dataset.contactQueued = 'true';
    captcha.protect(form, () => {
      delete form.dataset.contactQueued;
      if (!form.hasAttribute('data-hcaptcha-bound')) return;
      if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.submit();
    });
  });
})();
